// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QZwAO","navlinks":"Header_navlinks__B6UCW","active":"Header_active__y9yos"};